import React, { Suspense } from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";

import { createBrowserRouter, RouterProvider } from "react-router-dom";
import Map from "./components/map/Map";
import Barber from "./components/Barber";
import Footer from "./components/Footer";
import Gallery from "./pages/Gallery";
import AboutUs from "./pages/AboutUs";
import Connection from "./pages/Connection";
import Carrier from "./pages/Carrier";
import Navbar from "./components/Navbar";
import { APIProvider } from "@vis.gl/react-google-maps";

const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
  },
  {
    path: "/gallery",
    element: <Gallery />,
  },
  {
    path: "/about-us",
    element: <AboutUs />,
  },
  {
    path: "/connection",
    element: <Connection />,
  },
  {
    path: "/carrier",
    element: <Carrier />,
  },
  {
    path: "/artist-barbershops",
    element: <Map />,
  },
  {
    path: "/artist-barbershops/:city",
    element: <Map />,
  },
  {
    path: "barber/:barberName",
    element: (
      <div>
        <Navbar standAlone />
        <Barber />
        <Footer />
      </div>
    ),
  },
]);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <APIProvider apiKey={process.env.REACT_APP_MAP_KEY}>
      <Suspense fallback={<div>...loading</div>}>
        <RouterProvider router={router} />
      </Suspense>
    </APIProvider>
  </React.StrictMode>
);
